module.exports = __webpack_public_path__ + "media/images/athletes/1401-c39059e0bb6f2944cf5c2959eb4111bf.png";